enum AppointmentStatus {
    // I think the AppointmentStatus is not needed anymore. (It still used in CalendarEventStatusRequest)
    // for 'booked' status, and appointment would not existed if not booked.
    // for 'cancelled' status, and appointment would not existed if cancelled (should be deleted).
    // for 'confirmed' status, we have 'confirmed_at' field.
    // for 'follow_up' status, we have 'is_folllowing_up' field.

    /**
     * Open status is what every appointment is listed as initially.
     * As soon as you add an appointment, the appointment
     * is added to your schedule and in Open status.
     *
     * @var string
     */
    OPEN        = 'open',

    /**
     * Booked status is when the patient booked the appointment
     * but not yet confirmed by the staff
     *
     * @var string
     */
    BOOKED      = 'booked',

    /**
     * An appointment can be confirmed by the staff in the back office or the client.
     *
     * @var string
     */
    CONFIRMED   = 'confirmed',

    /**
     * A follow-up/check-up/recall appointment
     *
     * @var string
     */
    FOLLOW_UP   = 'follow_up',

    /**
     * As clients come in for their appointment, you can mark their appointment as Checked In.
     *
     * @var string
     */
    CHECKED_IN  = 'checked_in',

    /**
     * An appointment that's in Completed status means that the client has come in
     * and the service for the appointment has been successfully rendered.
     *
     * @var string
     */
    COMPLETED   = 'completed',

    /**
     * In our case i don't think we gon to use this status,
     * when cancelling an appointment it's only means make it open again for the public
     */
    CANCELLED   = 'cancelled',

    /**
     * It the client does not end up showing up for his/her appointment time,
     * you can mark the appointment as No Show.
     */
    //  NO_SHOW     = 'no_show',

    /**
     * An appointment can only be marked as In Progress by the staff only,
     * and this status helps staff determine when an appointment has started for
     * the purpose of tracking how much time a practitioner spends with a given client.
     */
    IN_PROGRESS = 'in_progress',
}

export default AppointmentStatus;
